import { render, staticRenderFns } from "./PageTemplate.vue?vue&type=template&id=9055baa6&scoped=true&"
import script from "./PageTemplate.vue?vue&type=script&lang=js&"
export * from "./PageTemplate.vue?vue&type=script&lang=js&"
import style0 from "./PageTemplate.vue?vue&type=style&index=0&id=9055baa6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9055baa6",
  null
  
)

export default component.exports